import React from "react";
import { Box } from "@mui/material";

const defaultSx = {
  position: "fixed",
  zIndex: 60,
  right: { xs: 0, sm: 24 },
  bottom: {
    xs: "env(safe-area-inset-bottom)",
    sm: 24,
  },
  width: { xs: "100%", sm: "auto" },
  p: { xs: 1.5, sm: 0 },
  backgroundColor: {
    xs: "rgba(0, 0, 0, 0.5)",
    sm: "transparent",
  },
  boxShadow: {
    xs: "0 -4px 12px rgba(0,0,0,0.12)",
    sm: "none",
  },
};

// sxを安全にマージするために配列へ正規化
const normalizeSx = (sx) =>
  [defaultSx, ...(Array.isArray(sx) ? sx : [sx])].filter(Boolean);

// PC・スマホ共通で使用する、画面右下のフローティングアクション配置用コンポーネント
const FloatingActionContainer = ({ children, sx }) => {
  return <Box sx={normalizeSx(sx)}>{children}</Box>;
};

export default FloatingActionContainer;
